import React from 'react';
import { galleryData } from '../data/mock';
import { Badge } from './ui/badge';

const Gallery = () => {
  return (
    <section className="bg-[#0d0d0d] py-20 md:py-32 overflow-hidden">
      <div className="max-w-[87.5rem] mx-auto px-5 md:px-10">
        {/* Section Header */}
        <div className="mb-12">
          <p className="font-['DM_Sans'] text-[#888680] text-sm uppercase tracking-widest">
            Built in the Gym. Captured by{' '}
            <span className="font-['Bebas_Neue'] text-base tracking-wide font-bold">
              FIT-FRAME
            </span>
            .
          </p>
        </div>

        {/* Horizontal Scrollable Gallery */}
        <div className="overflow-x-auto pb-4 -mx-5 md:-mx-10 px-5 md:px-10">
          <div className="flex gap-6 min-w-max">
            {galleryData.map((item) => (
              <div 
                key={item.id}
                className="relative w-80 h-96 rounded-lg overflow-hidden group cursor-pointer flex-shrink-0"
              >
                {item.type === 'Reel' && item.embedUrl ? (
                  // Instagram Embed
                  <>
                    <iframe
                      src={item.embedUrl}
                      className="w-full h-full"
                      frameBorder="0"
                      scrolling="no"
                      allowTransparency="true"
                      allow="encrypted-media"
                      title={item.alt}
                    />
                    {/* Top Right Badge for Instagram */}
                    <div className="absolute top-4 right-4 z-10">
                      <Badge className="bg-[#e8ff47] text-[#0d0d0d] font-['DM_Sans'] font-semibold uppercase text-xs px-3 py-1">
                        {item.type}
                      </Badge>
                    </div>
                  </>
                ) : (
                  // Regular Image
                  <>
                    <img 
                      src={item.image}
                      alt={item.alt}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    {/* Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    
                    {/* Badge - Top Right Corner Only */}
                    <div className="absolute top-4 right-4 z-10">
                      <Badge className="bg-[#e8ff47] text-[#0d0d0d] font-['DM_Sans'] font-semibold uppercase text-xs px-3 py-1">
                        {item.type}
                      </Badge>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Scroll Hint */}
        <p className="font-['DM_Sans'] text-[#888680] text-sm text-center mt-8">
          ← Scroll to see more →
        </p>
      </div>
    </section>
  );
};

export default Gallery;
